import { ReactElement } from 'react';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { filterPractitionersWithMedicalLicenceNumber } from '~legacy.personnel';

import { prescriptionVisitsTranslationKeys } from '../../translations';
import { PrescriptionVisitForm } from '../form/PrescriptionVisitForm';
import { restoreFormInitializer } from '../form/PrescriptionVisitForm.utils';

import { PrescriptionVisitRestoreModalLoader } from './PrescriptionVisitRestoreModal.loader';
import { PrescriptionVisitSaveButton } from './PrescriptionVisitSaveButton';

type PrescriptionVisitRestoreModalProps = {
   readonly appointmentId: number;
   readonly onClose: VoidFunction;
};

export const PrescriptionVisitRestoreModal = (props: PrescriptionVisitRestoreModalProps): ReactElement => {
   return (
      <Modal
         testId={'prescriptionVisitRestoreModal'}
         title={prescriptionVisitsTranslationKeys.restore}
         onCloseRequest={props.onClose}
         width={ModalWidth.WIDE}
         visible
         animateVisibility
      >
         <PrescriptionVisitRestoreModalLoader appointmentId={props.appointmentId}>
            {({ appointment, patient, practitioners, healthcareProviderLocations, receptionServices }) => {
               const filteredPractitioners = filterPractitionersWithMedicalLicenceNumber(practitioners);

               return (
                  <PrescriptionVisitForm
                     initializer={restoreFormInitializer(
                        appointment,
                        patient,
                        healthcareProviderLocations,
                        filteredPractitioners,
                        receptionServices
                     )}
                     practitioners={filteredPractitioners}
                     healthcareProviderLocations={healthcareProviderLocations}
                     receptionServices={receptionServices}
                  >
                     {({ handleSubmit, formState }) => (
                        <>
                           <PrescriptionVisitSaveButton
                              handleSubmit={handleSubmit}
                              onSuccess={props.onClose}
                              label={prescriptionVisitsTranslationKeys.restore}
                           />
                           <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                           <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                        </>
                     )}
                  </PrescriptionVisitForm>
               );
            }}
         </PrescriptionVisitRestoreModalLoader>
      </Modal>
   );
};
